export const MY_STORY_MENU = [{label: '삭제하기', type: 'delete'}];
export const MY_HOTISSUE_MENU = [
  {label: '방송국 가기', type: 'station'},
  {label: '게시물 안보기', type: 'no'},
];
